export default __webpack_public_path__ + "static/media/getwell.84993a54.png";